module.exports = __webpack_public_path__ + "static/media/nr.b3fdadbc.svg";